import { render, staticRenderFns } from "./AllFiltersButton.vue?vue&type=template&id=48877712"
import script from "./AllFiltersButton.vue?vue&type=script&lang=ts"
export * from "./AllFiltersButton.vue?vue&type=script&lang=ts"
import style0 from "./AllFiltersButton.vue?vue&type=style&index=0&id=48877712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports